import { render, staticRenderFns } from "./SedativeInput.vue?vue&type=template&id=02d5421a&"
import script from "./SedativeInput.vue?vue&type=script&lang=js&"
export * from "./SedativeInput.vue?vue&type=script&lang=js&"
import style0 from "./SedativeInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VFlex,
  VIcon,
  VLayout,
  VSelect,
  VTextField,
})
